var WordModel = require('./word'),
    Box = require('./box'),
    SubWordReference = require('./subWordReference');


var modelDefaults =  _.extend( {}, WordModel.prototype.defaults, {

    isDerived: true,

    isMultiPage: false,
    isMultiLine: false,
    isMultiZone: false,

    // Could rid -- used to create subWordReferences in squashes dashes routine
    subwordIds: [],
    subwordPageLevelKeys: [], // currently for debug -- don't think necessary here

    subWordReferences: [] // id's back to reference the subwords

});

// Ignore values that have no meaning here -- explicitly remove from the defaults
modelDefaults = _.omit( modelDefaults,
    'boxPx', 'boxFDDZoneUnits', 'derivedParentId',
    'page_level_id', 'page_level_key',
    'pageLevelLineId', 'pageLevelLineWordId', 'pageLevelZoneId', 'pageLevelZoneLineId', 'pageLevelZoneWordId'
);


module.exports = WordModel.extend({

    defaults: modelDefaults,

    // Really just want to set the attributes from a combo of each as pass to Backbone Model constructor
    // Now only created from the derived words sqashed dash routine
    constructor: function( word1, word2, word1TextFirst ) {


        var wd = word1TextFirst
            ? word1.get('wd') + word2.get('wd')
            : word2.get('wd') + word1.get('wd');

        var isTextSanitized = word1.get('isTextSanitized') || word2.get('isTextSanitized');

        // Prob not necessary -- but stored the originalWdText for derived word ( may be good for debug )
        var originalWd = isTextSanitized
            ? getOriginalWdText( word1, word2, word1TextFirst )
            : null; // ( don't attempt if N/A )

        /**
         * subwordIds, subwordPageLevelKeys are temporary; used to create subWordReferences
         * Could do some of the work in post-process but that's less clear and only provides a negligible performance boost
         * Note: need to include  word.get('subwordIds') in addition to the word ids here -- eg if '-' and combo, if won't carry over those added in previous iteration
         */

        var subwordIds =
            ensureArray(word1.get('subwordIds')).concat(
                ensureArray(word2.get('subwordIds')), [word1.id, word2.id]
            );
        subwordIds = _.reject(subwordIds, function (i) {
            return i === null;
        }); // can be null if derived and not yet set ( would be word 1 or 2)
        subwordIds = _.unique(subwordIds);
        subwordIds = _.sortBy(subwordIds, function (i) {
            return i;
        });

        var subwordPageLevelKeys =
            ensureArray(word1.get('subwordPageLevelKeys')).concat(
                ensureArray(word2.get('subwordPageLevelKeys')), [word1.get('page_level_key'), word2.get('page_level_key')]
            );
        subwordPageLevelKeys = _.reject(subwordPageLevelKeys, function (i) {
            return i === null;
        });
        subwordPageLevelKeys = _.unique(subwordPageLevelKeys); // not really necessary
        subwordPageLevelKeys = _.sortBy(subwordPageLevelKeys, function (i) {
            return i;
        }); // not really necessary


        var pageId = getUniqueArrayFromArrayOrItems(word1.get('pageId'), word2.get('pageId'), 1);
        var pageNumber = getUniqueArrayFromArrayOrItems(word1.get('pageNumber'), word2.get('pageNumber'), 1);
        var docLevelLineId = getUniqueArrayFromArrayOrItems(word1.get('docLevelLineId'), word2.get('docLevelLineId'), 1);
        var docLevelZoneId = getUniqueArrayFromArrayOrItems(word1.get('docLevelZoneId'), word2.get('docLevelZoneId'), 1);


        WordModel.call(this, {

            wd: wd,
            originalWd: originalWd,
            isTextSanitized: isTextSanitized,

            subwordIds: subwordIds,
            subwordPageLevelKeys: subwordPageLevelKeys,

            pageId: pageId, // (array if > 1 )
            pageNumber: pageNumber, //(array if > 1 )
            docLevelLineId: docLevelLineId, //(array if > 1 )
            docLevelZoneId: docLevelZoneId, // array if > 1

            isMultiPage: pageId instanceof Array,
            isMultiLine: docLevelLineId instanceof Array,
            isMultiZone: docLevelZoneId instanceof Array,

            boxPxDerived: word1.get('boxPxDerived').combo(word2.get('boxPxDerived')),
            boxFDDZoneUnitsDerived: word1.get('boxFDDZoneUnitsDerived').combo(word2.get('boxFDDZoneUnitsDerived'))


        });


        function ensureArray(a) {
            return a
                ? a instanceof Array
                ? a
                : [a]
                : [];
        }

        // Now will also return string if only one item
        // And if not array, just return 1
        function getUniqueArrayFromArrayOrItems(a, b, sort) {

            var aArray = a instanceof Array ? a : [a];
            var bArray = b instanceof Array ? b : [b];
            var combinedUniqueArray = _.unique(aArray.concat(bArray));

            if (combinedUniqueArray.length === 1)
                return combinedUniqueArray[0];

            return !sort
                ? combinedUniqueArray
                : _.sortBy(combinedUniqueArray, function (i) {
                return i;
            });
        }

        // Not as simple as getting the wd: word1 or word2 may not have sanitized text,
        // so it can be a combo of wd and originalWord.
        function getOriginalWdText( word1, word2, word1TextFirst ) {

            var word1Txt = word1.get('isTextSanitized')
                ? word1.get('originalWd')
                : word1.get('wd');

            var word2Txt = word2.get('isTextSanitized')
                ? word2.get('originalWd')
                : word2.get('wd');

            return word1TextFirst
                ? word1Txt + word2Txt
                : word2Txt + word1Txt;

         }


    },

    postProcessCombinedWord: function() {

        var pageId = this.get('pageId');
        var pageNumber = this.get('pageNumber');

        var subWordReferences = _.map( this.get('subwordIds'), function(subWordId, i) {

            return new SubWordReference({
                originalId: subWordId,
                pageLevelKey: this.get('subwordPageLevelKeys')[i],
                parentId: this.id,
                pageId: pageId instanceof Array ? pageId[i] : pageId,
                pageNumber: pageNumber instanceof Array ? pageNumber[i] : pageNumber
            });

        }, this);


        this.set( 'subWordReferences', subWordReferences );


    },

    // Should never get here
    parse: function(attrs) {

        return attrs;

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/positionalTextModels/textAreaModels/derivedWord.js
 ** module id = 408
 ** module chunks = 0
 **/